// number of seconds in a minute
export const SECONDS_IN_MINUTE = 60;

// number of seconds in an hour
export const SECONDS_IN_HOUR = SECONDS_IN_MINUTE * SECONDS_IN_MINUTE;

// number of seconds in a day
export const SECONDS_IN_DAY = 24 * SECONDS_IN_HOUR;
